import React, { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { LoginForm } from "../components/LoginForm";

const ResetPasswordPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const query = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const uid = query.get("uid") || "";
  const token = query.get("token") || "";

  const goToLogin = () => {
    navigate("/login", { replace: true });
  };

  return (
    <LoginForm
      initialModal="reset"
      resetModal={{
        uid,
        token,
        onClose: goToLogin,
        onSuccess: goToLogin,
      }}
    />
  );
};

export default ResetPasswordPage;
